var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_327_25",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7411 0.566503L0 25.3076L24.7411 50.0487L49.4822 25.3076L24.7411 0.566503Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_327_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1117 37.6782C43.9437 30.8462 43.9437 19.7692 37.1116 12.9372C30.2795 6.1051 19.2025 6.10508 12.3706 12.9371C5.53844 19.7692 5.5385 30.8461 12.3706 37.6782C19.2026 44.5103 30.2796 44.5103 37.1117 37.6782Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 32.1753L32.1752 18.0001",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 18L32.1755 32.1754",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.7904,
    height: 35.7904,
    fill: "white",
    transform: "translate(0 25.3076) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.b936b1193d099e608b73c6a2d1eed477.svg";
export { ForwardRef as ReactComponent };